import React, { Fragment } from 'react';

import './styles/progress.css';

const ProgressComponent = ({ step, totalSteps, setStep }) => {


    return(
        <div className="d-flex justify-content-between align-items-center step-container">
            {[...Array(totalSteps)].map((_, index) => {
                const stepNumber = index + 1;
                return (
                    <React.Fragment key={stepNumber}>
                        <div
                            className={`step-dot ${step >= stepNumber ? "active" : ""}`}
                            onClick={() => setStep(stepNumber)}
                        >
                            {stepNumber}
                        </div>
                        {stepNumber < totalSteps && <div className="step-line"></div>}
                    </React.Fragment>
                );
            })}
        </div>
    )
}

export default ProgressComponent;
